import React from 'react';

const Details = () => {
    return (
        <div>
            <h1>Please Enroll Now</h1>
            
        </div>
    );
};

export default Details;